$(document).on('click', '[data-maximize]', (e) => {
  e.preventDefault();

  const id = e.currentTarget.dataset.maximize;
  const el = document.querySelector(`[data-maximize-id="${id}"]`);
  const icon = e.currentTarget.querySelector('bu-icon');
  el.classList.toggle('maximized');
  icon.name = icon.name === 'maximize' ? 'minimize' : 'maximize';
});
